<script setup lang="ts">
const el = ref<HTMLElement | null>(null)
const strength = 0.15

function onMouseMove(e: MouseEvent) {
  if (!el.value) return
  const rect = el.value.getBoundingClientRect()
  const x = e.clientX - rect.left - rect.width / 2
  const y = e.clientY - rect.top - rect.height / 2
  el.value.style.transform = `translate(${x * strength}px, ${y * strength}px)`
}

function onMouseLeave() {
  if (!el.value) return
  el.value.style.transform = 'translate(0, 0)'
  el.value.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
}

function onMouseEnter() {
  if (!el.value) return
  el.value.style.transition = 'transform 0.15s ease-out'
}
</script>

<template>
  <div
    ref="el"
    class="inline-block"
    @mousemove="onMouseMove"
    @mouseleave="onMouseLeave"
    @mouseenter="onMouseEnter"
  >
    <slot />
  </div>
</template>
